
// vue
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'CustomInput',
  props: {
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    showCopyBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: String,
      required: true,
      default: '',
    },
    max: {
      type: Number,
      required: false,
      default: 5000,
    },
    min: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  setup() {
    const showCopiedMsg = ref(false);
    const writeToClipboard = (text: string) => {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          showCopiedMsg.value = true;
          setTimeout(() => {
            showCopiedMsg.value = false;
          }, 2000);
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const inputRef = ref<null | HTMLInputElement>(null);
    const focusInput = () => {
      if (inputRef.value) {
        inputRef.value.select();
        // inputRef.value.focus();
      }
    };
    return {
      showCopiedMsg,
      writeToClipboard,
      inputRef,
      focusInput,
    };
  },
});
